import { AuthFetch } from "../../Redux/Reducers/AuthFetchReducer";
import store from "../../store";

const {dispatch} = store;

export const GlobalAuthFetch=(options)=>dispatch(AuthFetch(options))